export const AI_FUNNEL_ONLY_EMAIL = "aifunnel@earlyjobs.in";

export const isAiFunnelOnlyUser = (user?: { email?: string } | null) =>
  String(user?.email || "").trim().toLowerCase() === AI_FUNNEL_ONLY_EMAIL.toLowerCase();
